'use strict'

const states = {
  HANDSHAKING: 'handshaking',
  STATUS: 'status',
  LOGIN: 'login',
  CONFIGURATION: 'configuration',
  PLAY: 'play'
}

module.exports = states
